<template>
  <div class="dayplanner-sidebar">

    <div class="dayplanner-topbar d-flex hamburger-spacer" style="align-items: center; justify-content: space-around;">
      <el-button @click="onSidebarNavigation('TODAY')" :class="{ 'el-button--selected': currentTab === 'TODAY', 'dayplanner-sidebar__button': true }">
        <strong>Today's Goals</strong>
      </el-button>
      <el-button @click="onSidebarNavigation('SIMPLE')" :class="{ 'el-button--selected': currentTab === 'SIMPLE', 'dayplanner-sidebar__button': true }">
        <strong>My Goals</strong>
      </el-button>
      <el-button @click="onSidebarNavigation('TOOLBOXES')" :class="{ 'el-button--selected': currentTab === 'TOOLBOXES', 'dayplanner-sidebar__button': true }">
        <strong>Templates</strong>
      </el-button>
      <el-button @click="onSidebarNavigation('CHAT')" :class="{ 'el-button--selected': currentTab === 'CHAT', 'dayplanner-sidebar__button': true }">
        <el-badge :value="numOfUnreadMessages" type="primary">
          <strong>Chat</strong>
        </el-badge>
      </el-button>
      <!--
      <el-button @click="onSidebarNavigation('TOOLBOXES')" :class="{ 'el-button--selected': currentTab === 'TOOLBOXES', 'dayplanner-sidebar__button': true }">
        <strong>Toolboxes</strong>
      </el-button>
      -->
      <el-button v-if="!is_production" @click="onSidebarNavigation('MISC')" :class="{ 'el-button--selected': currentTab === 'MISC', 'dayplanner-sidebar__button p-1': true }">
        <span>⚙️</span>
      </el-button>
    </div>

    <template v-if="currentTab === 'TODAY'">
      <!-- style="box-shadow: inset 0px 4px 6px 0px #444d563d;" -->
      <SidebarToday
        @add="onAddItem"
        @first-move="onFirstMove"
        @drag-end="onDragEnd"
      />
    </template>

    <template v-if="currentTab === 'SIMPLE'">
      <SidebarSimple />
    </template>

    <template v-if="currentTab === 'TOOLBOXES'">
      <SidebarToolboxes />
    </template>

    <template v-if="currentTab === 'MISC'">
      <SidebarMisc />
    </template>

    <template v-if="currentTab === 'CHAT'">
      <SidebarChat />
    </template>

  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import SidebarToday from "@/components/TodayPage/Elements/SidebarToday";
import SidebarSimple from "@/components/TodayPage/Elements/SidebarSimple";
import SidebarMisc from "@/components/TodayPage/Elements/SidebarMisc";
import SidebarChat from "@/components/TodayPage/Elements/SidebarChat";
import SidebarToolboxes from "@/components/TodayPage/Elements/SidebarToolboxes";

export default {
  props: {
  },
  data: () => ({
    is_production: process.env.VUE_APP_PRODUCTION !== 'false',
  }),
  computed: {
    ...mapGetters("app", [
      "active_sidebar_menu",
      "active_user_chat",
    ]),

    currentTab() {
      return this.active_sidebar_menu
    },

    numOfUnreadMessages() {
      let num = this.$models.userContact.getters.numOfAllUnreadMessages
      return num === 0 ? null : num;
    }
  },
  methods: {
    ...mapMutations("app", [
      "SET_ACTIVE_SIDEBAR_MENU",
    ]),

    onSidebarNavigation(target) {
      console.log("onSidebarNavigation", target)
      this.SET_ACTIVE_SIDEBAR_MENU( target )
    },

    onAddItem($event) {
      // TODO: move to vuex?
      this.$emit('add', $event)
    },

    onFirstMove($event) {
      this.$emit('first-move', $event)
    },

    onDragEnd($event) {
      this.$emit('drag-end', $event)
    },
  },
  components: {
    SidebarToday,
    SidebarSimple,
    SidebarMisc,
    SidebarToolboxes,
    SidebarChat,
  }
};
</script>

<style>
.dayplanner-sidebar__button {
  margin-left: 0 !important;
  padding: 12px 6px;
  border: none;
  /*background-color: #f0f0f0;*/
}
.dayplanner-sidebar {
/*  padding: 0.75em;
  height: 100vh;
  overflow-y: scroll;
  border-right: 1px solid gray;*/
}
.dayplanner-sidebar .el-card.is-always-shadow {
  /* fix shadow */
  box-shadow: 0 4px 7px -3px rgba(0, 0, 0, 0.1);
}
/* move to global */
.el-button--selected {
  color: #1c6980;
  background-color: #add0f7;
}
</style>
